import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Navigation from '../components/Navigation';
import StaffSection from '../components/StaffSection';
import Footer from '../components/Footer';
import SEO from '../components/SEO';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const TeamPage = () => {
  const [staff, setStaff] = useState([]);

  useEffect(() => {
    const fetchStaff = async () => {
      try {
        const response = await axios.get(`${API}/staff`);
        setStaff(response.data);
      } catch {
        // Error handled silently
      }
    };
    fetchStaff();
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Our Expert Team"
        description="Meet the licensed therapists, counselors, and rehabilitation specialists at SDORA Wellbeing in Pikesville, MD. Culturally competent care. Accepting Medicaid."
        path="/team"
        image="https://static.prod-images.emergentagent.com/jobs/01501ca6-ddde-43b6-bfc5-0444b2f0bae0/images/fb91eca4d3c75f45e0ff4d66eb941c17ca86865298fad50d292b158629b965ff.jpeg"
      />
      <Navigation />
      
      {/* Page Header */}
      <div className="bg-gradient-to-br from-blue-50 to-purple-50 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Meet Our Expert Team
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl">
            Our highly skilled professionals are dedicated to providing compassionate, evidence-based care tailored to your unique needs.
          </p>
          <p className="text-gray-600 max-w-3xl mt-4">
            Our team brings together licensed therapists, a board-certified psychiatric nurse practitioner, certified
            rehabilitation specialists, and dedicated case managers, each bringing their own clinical background and
            lived experience to the table. We believe effective care starts with representation and cultural
            competence, which is why our clinicians reflect the diverse communities we serve across Pikesville and
            Baltimore County.
          </p>
        </div>
      </div>

      <StaffSection staff={staff} />
      <Footer />
    </div>
  );
};

export default TeamPage;